(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (!customElements.get('si-collection-navigation')) {
    customElements.define('si-collection-navigation', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.si-collection-nav__rail');
        if (!this.rail) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.rail.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail) return;
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          }
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.rail);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
      update() {
        const overflow = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        const position = Math.min(overflow, Math.abs(this.rail.scrollLeft));
        const rtl = getComputedStyle(this).direction === 'rtl';
        const moreBefore = overflow > 2 && position > 2;
        const moreAfter = overflow > 2 && position < overflow - 2;
        this.toggleAttribute('data-more-left', rtl ? moreAfter : moreBefore);
        this.toggleAttribute('data-more-right', rtl ? moreBefore : moreAfter);
      }
      move(direction) {
        const rtl = getComputedStyle(this).direction === 'rtl';
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollBy({ left: direction * (rtl ? -1 : 1) * this.rail.clientWidth * .8, behavior: reducedMotion ? 'instant' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('si-rich-text-collapse')) {
  customElements.define('si-rich-text-collapse', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-collapse-content]');
      this.toggle = this.querySelector('[data-collapse-toggle]');
      if (!this.content || !this.toggle) return;
      this.onToggle = () => this.setExpanded(this.toggle.getAttribute('aria-expanded') !== 'true', true);
      this.onBlockSelect = event => {
        if (this.content.contains(event.target)) this.setExpanded(true);
      };
      this.toggle.addEventListener('click', this.onToggle);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.setExpanded(false);
      this.toggle.hidden = false;
    }
    setExpanded(expanded, fromClick = false) {
      const wasAboveViewport = this.getBoundingClientRect().top < 0;
      this.content.hidden = !expanded;
      this.toggle.setAttribute('aria-expanded', String(expanded));
      if (!expanded && fromClick && wasAboveViewport) {
        this.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    }
    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.onToggle);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-collection-seo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('si-c03-disclosure')) {
 customElements.define('si-c03-disclosure', class extends HTMLElement {
  connectedCallback() {
   this.details = this.querySelector('details');
   if (!this.details) return;
   this.media = window.matchMedia('(max-width: 749px)');
   this.sync = () => { this.details.open = !(this.media.matches && this.dataset.collapse === 'true'); };
   this.onSelect = event => { if (this.contains(event.target)) this.details.open = true; };
   this.media.addEventListener('change', this.sync);
   this.addEventListener('shopify:block:select', this.onSelect);
   this.sync();
  }
  disconnectedCallback() {
   if (this.media) this.media.removeEventListener('change', this.sync);
   if (this.onSelect) this.removeEventListener('shopify:block:select', this.onSelect);
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
